(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evenlyr-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.evenlyr-catalog').forEach((catalog) => {
    const tabs = Array.from(catalog.querySelectorAll('[data-evenlyr-tab]'));
    const panels = Array.from(catalog.querySelectorAll('[data-evenlyr-panel]'));

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.evenlyrTab;

        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const selected = panel.id === targetId;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
